import { FiSearch } from "react-icons/fi";
import styles from "./Clients.module.css";
import { useEffect, useState } from "react";
import Client from "../../components/Client/Client";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa6";
import { fetchTherapistClients } from "actions/dataLoad";
import { useUserTokenSelector } from "store/reducers";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { startLoading, stopLoading } from "store/actions";

const Clients = () => {
  const userToken = useUserTokenSelector();
  const currMonth = new Date().getMonth() + 1;
  const currYear = new Date().getFullYear();
  const [month, setMonth] = useState(currMonth);
  const [year, setYear] = useState(currYear);
  const [cindex, setCindex] = useState();
  const [client, setClient] = useState(null);
  const [showClient, setShowClient] = useState(false);
  const [clients, setClients] = useState([]);
  const [searchText, setSearchText] = useState("");
  const monthNames = ["All", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const avatar = {
    female: "https://ucarecdn.com/c22b8f55-8c68-411e-a5c9-8b5b99c08701/femaleEmoji.svg",
    male: "https://ucarecdn.com/52c99efd-cba4-4fe1-93f2-e393088b7a0c/male.svg",
    other: "https://ucarecdn.com/c7bb4c01-2258-428d-b8ce-e2196ee63220/lgbtq.svg",
  };
  const { clientId } = useParams();
  const dispatch = useDispatch();

  const history = useHistory();

  useEffect(() => {
    const getClientsData = async () => {
      try {
        dispatch(startLoading(true))
        const res = await fetchTherapistClients( {month, year}, userToken);
        setClients(res?.data?.data || []);
        dispatch(stopLoading(false))
      } catch (err) {
        console.error("Error fetching clients:", err);
      }
    };

    getClientsData();
  }, [userToken, month, year]);

  const handleShowClient = (client, index) => {
    setClient(client);
    setCindex(index);
    setShowClient(true);
    history.push("/dashboard/therapist/clients/" + ((client.upcomingSession || client.pastSession)?.userID));
  };

  const handleCloseClient = () => {
    setClient(null);
    setCindex(null);
    setShowClient(false);
    history.push("/dashboard/therapist/clients");
  };

  const sortClients = (clientsToSort) => {
    const statusOrder = {
      "New Client": 1,
      "Active": 2,
      "Not Active": 3,
    };

    return [...clientsToSort].sort((a, b) => {
      const statusA = statusOrder[a.status] || 4; // Default to a lower priority if status is unknown
      const statusB = statusOrder[b.status] || 4;

      if (statusA !== statusB) {
        return statusA - statusB; // Sort by status priority
      }

      // If statuses are the same, sort by past session time (most recent first)
      const timeA = a.pastSession?.sessionTime?.start ? new Date(a.pastSession.sessionTime.start).getTime() : 0;
      const timeB = b.pastSession?.sessionTime?.start ? new Date(b.pastSession.sessionTime.start).getTime() : 0;
      return timeB - timeA; // Descending order for time
    });
  };

  const renderSymptoms = (client) => {
    if (!(client.upcomingSession || client.pastSession)?.problemCategory.length === 0) {
      return <p>-</p>;
    }
    return (client.upcomingSession || client.pastSession)?.problemCategory.map((symptom, index) => (
      <p key={index}>
        {symptom}
        {index < (client.upcomingSession || client.pastSession)?.problemCategory.length - 1 ? ", " : ""}
      </p>
    ));
  };

  useEffect(() => {
    if (clients.length > 0 && clientId) {
      const clientIdx = clients.findIndex((res) => (res.upcomingSession || res.pastSession).userID === clientId);
      if (clientIdx < 0) {
        return;
      }
      const client = clients[clientIdx];
      handleShowClient(client, clientIdx);
    }
    else if (!clientId) {
      handleCloseClient();
    }
  }, [clients, clientId]);

  useEffect (() => {
    setSearchText("")
  }, [showClient]);

  return (
    <div className="dashboardofboxes">
      {showClient ? (
        <Client onClose={handleCloseClient} client={client} clientId={(client.upcomingSession || client.pastSession).userID} />
      ) : (
        <>
          <p className={`${styles["dashboard-heading"]} ${styles.myclient}`}>My Clients</p>
          <div className={styles["clients-top"]}>
            <div className={styles.search}>
              <FiSearch size={18} />
              <input
                type="text"
                className={styles["search-input"]}
                placeholder="Search"
                onChange={(e) => {
                  setSearchText(e.target.value);
                }}
              />
            </div>
            <div className={`${styles["client-filter"]} ${styles.screen}`}>
              <select value={month} onChange={(e) => setMonth(e.target.value)}>
                {monthNames.map((m, index) =>
                  year === currYear && index > currMonth ? null : (
                    <option key={index} value={index}>
                      {m}
                    </option>
                  )
                )}
              </select>
              <select
                value={year}
                onChange={(e) => {
                  setYear(e.target.value);
                }}
              >
                <option value={currYear - 1}>{currYear - 1}</option>
                <option value={currYear}>{currYear}</option>
              </select>
            </div>
          </div>
          <div className={styles["client-table"]}>
            <div className={styles["client-head"]}>
              <p className={styles["th-name"]}>Name</p>
              <p className={styles["th-status"]}>Status</p>
              <p className={styles["th-symptoms"]}>Symptoms</p>
              <p className={styles["th-lsession"]}>
                Last session
                <br />
                date
              </p>
              <p className={styles["th-upsession"]}>
                Upcoming session
                <br />
                Date & time
              </p>
            </div>
            <div className={styles["client-body"]}>
              {clients &&
                sortClients(clients)
                  .filter((client) => client.name.toLowerCase().includes(searchText.toLowerCase()))
                  //   .filter(client => {
                  //   if (month === 0) return true;
                  //   const sessionDate = client.pastSession?.sessionDate;
                  //   return sessionDate && moment(sessionDate).month() + 1 === month && moment(sessionDate).year() === year;
                  // })
                  .map((client, index) => (
                    <div key={index} className={`${styles["client-div"]} ${index < clients.length - 1 ? styles.underline : ""}`}>
                      <div className={styles["client-name"]} onClick={() => handleShowClient(client, index)}>
                        <img src={client.avatar_url? client.avatar_url : avatar[client.gender || "other"]} alt="user-avatar" className={styles["clients-img"]} />
                        <div className={styles["client-name-mid"]}>
                          <div>
                            <h3 className={styles["name"]}>{client.name}</h3>
                            <div className={styles["link"]}>
                              <p>
                                Age: {client.age || client.upcomingSession.userAge || client.pastSession.userAge || ""}
                                {" yrs"}
                              </p>
                            </div>
                          </div>
                          <div className={styles["link-icon"]}>
                              <FaArrowRight size={16} />
                          </div>
                        </div>
                      </div>
                      <div
                          className={styles["chat-div"]}
                          onClick={(e) => {e.stopPropagation(); history.push(`/dashboard/therapist/chats/${(client.upcomingSession || client.pastSession)?.userID}`)}}
                        >
                          <IoChatbubbleEllipsesOutline size={14} color="white" />
                        </div>
                      <div className={styles["client-status"]}>
                        <span className={styles["mobile-head"]}>Status:</span>
                        <div
                          className={`${styles["status-div"]} ${
                            client.status === "New Client"
                              ? styles.new
                              : client.status === "Active"
                              ? styles.active
                              : styles.nactive
                          }`}
                        ></div>
                        <p>{client.status}</p>
                      </div>
                      <div className={styles["symptoms"]}>
                        <span className={styles["mobile-head"]}>Symptoms:</span>
                        <p>{renderSymptoms(client)}</p>
                      </div>
                      <div className={styles["lsession"]}>
                        <span className={styles["mobile-head"]}>Last Session:</span>
                        <p>{(client.pastSession)?.sessionDate || "-"}</p>
                      </div>
                      <div className={styles["upsession"]}>
                        <span className={styles["mobile-head"]}>Upcoming Session:</span>
                        <p>{(client.upcomingSession)?.sessionDate || "-"}</p>
                      </div>
                    </div>
                  ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Clients;
